import package1Icon from 'assets/images/shoppage-package1.svg'
import package2Icon from 'assets/images/shoppage-package2.svg'
import package3Icon from 'assets/images/shoppage-package3.svg'
import package4Icon from 'assets/images/shoppage-package4.svg'
import package5Icon from 'assets/images/shoppage-package5.svg'
import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import bestSaleIcon from 'assets/images/shoppage-bestsale.svg'
import ConfirmModal from 'components/Modal/ConfirmModal'
import { useState } from 'react'
import OTPConfirmModal from 'components/Modal/OTPConfirmModal'
import { useQuery } from 'react-query'
import { useBuyPackage, useShopOTP } from 'dataLayer/user'
import { getUserinfo } from 'utils/localStorage'
import LoginWebModal from 'components/Modal/LoginWebModal'
import { userDataAtom } from 'config/store'
import CancelModal from 'components/Modal/CancelModal'
import { useCancelPackage } from 'dataLayer/game'
import { useDispatch } from 'react-redux'
import { showSnackbar } from 'store/actions'
import { Link } from 'react-router-dom'

function PackageCard({
	data,
	isSubscription,
	tabValue,
	isRegisted = 0,
	packageCurrent = 'null',
	handleLocalstorage = () => { },
}) {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const packageIconArr = [
		package1Icon,
		package2Icon,
		package3Icon,
		package4Icon,
		package5Icon,
	]
	const [itemSelect, setItemSelect] = useState({})
	const [transactionId, setTransactionId] = useState('')
	const DOMAIN_UID = process.env.REACT_APP_DOMAIN_UID
	const CLIENTID = process.env.REACT_APP_CLIENTID
	const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI
	const [modalShowLoginPass, setModalShowLoginPass] = useState(false)
	function openLoginModal() {
		// setModalShowLoginPass(true)
		window.location.href = `${DOMAIN_UID}?client_id=${CLIENTID}&redirect_uri=${REDIRECT_URI}&use_callback_uri=true`
	}
	const user = getUserinfo()
	const { mutate: shopOTP } = useShopOTP(
		result => {
			setTransactionId(result?.content)
			setModalConfirm(false)
			setModalShowOTP(true)
		},
		error => {
			dispatch(showSnackbar(true, error?.message || t('modal.error'), 'error'))
		},
	)
	const { mutate: buyPackage } = useBuyPackage(
		result => {
			setTransactionId(result?.content)
			setModalConfirm(false)
			setModalShowOTP(true)
		},
		error => {
			dispatch(showSnackbar(true, error?.message || t('modal.error'), 'error'))
		},
	)
	const { mutate: cancelPackage } = useCancelPackage(
		data => {
			itemSelect?.packageType === 1
				? handleLocalstorage({ isRegisted: 0 })
				: handleLocalstorage({ packageCurrent: 'null' })
			dispatch(showSnackbar(true, t('modal.success'), 'success'))
		},
		error => {
			dispatch(showSnackbar(true, error?.message || t('modal.error'), 'error'))
		},
	)

	const [modalConfirm, setModalConfirm] = useState(false)
	const [modalCancel, setModalCancel] = useState(false)
	const [packageSelect, setPackageSelect] = useState(false)
	function openConfirmModal(item) {
		if (getUserinfo()) {
			setItemSelect(item)
			setModalConfirm(true)
			setPackageSelect(item?.name)
		} else {
			openLoginModal()
		}
	}
	const openCancelModal = item => {
		if (getUserinfo()) {
			setItemSelect(item)
			setModalCancel(true)
			setPackageSelect(item?.name)
		} else {
			openLoginModal()
		}
	}
	function closeConfirmModal() {
		setModalConfirm(false)
	}
	function closeCancelModal() {
		setModalCancel(false)
	}
	const handleCancel = () => {
		cancelPackage({
			package_id: itemSelect.packageCode,
		})
		setModalCancel(false)
	}
	const [modalShowOTP, setModalShowOTP] = useState(false)
	function openOTPAndCloseConfirmModal() {
		if (tabValue === 2) {
			buyPackage({
				package_id: itemSelect.packageCode,
				command: itemSelect.command,
			})
		} else if (tabValue === 1) {
			shopOTP({
				package_id: itemSelect.packageCode,
			})
		}
	}
	function closeOTPModal() {
		setModalShowOTP(false)
	}
	return (
		<>
			{data?.map((item, index) => {
				return (
					<div
						className={`package ${isSubscription ? 'sub' : ''} mb-0 mb-md-3`}
						key={item?.id}
					>
						<div>
							<h2 className="text-center">{item?.name}</h2>
							<p className="text-center">
								{t('shoppage.reward_desc').replace(
									'_GOLD_',
									new Intl.NumberFormat('lo').format(parseInt(item?.coin)),
								)}
							</p>
						</div>
						<img src={packageIconArr[index]} alt="Package type" />
						{isRegisted && isRegisted === 1 ? (
							// ||
							// 	item?.name.toLowerCase().includes(packageCurrent.toLowerCase())

							<Button
								style={{ background: 'red' }}
								onClick={() => openCancelModal(item)}
							>
								{t('shoppage.cancel').replace('{name-package}', item?.name)}
							</Button>
						) : getUserinfo() ? (
							<Button onClick={() => openConfirmModal(item)}>
								{t('shoppage.buy').replace(
									'_PRICE_',
									new Intl.NumberFormat('lo').format(parseInt(item?.fee)),
								)}
							</Button>
						) : (
							<Button
							// onClick={() => openConfirmModal(item)}
							>
								<Link
									style={{ color: 'white' }}
									to={`${DOMAIN_UID}?client_id=${CLIENTID}&redirect_uri=${REDIRECT_URI}&use_callback_uri=true`}
								>
									{t('shoppage.buy').replace(
										'_PRICE_',
										new Intl.NumberFormat('lo').format(parseInt(item?.fee)),
									)}
								</Link>
							</Button>
						)}

						{item.isHot === 1 ? (
							<img
								src={bestSaleIcon}
								className="bestsale"
								alt="Bestsale package"
							/>
						) : null}
					</div>
				)
			})}
			{user ? (
				<ConfirmModal
					show={modalConfirm}
					onHide={closeConfirmModal}
					title={t('modal.shop.are_you_sure').replace(
						'_PACKAGE_',
						packageSelect,
					)}
					onShowOTP={openOTPAndCloseConfirmModal}
				/>
			) : // : modalShowLoginPass ? (
				// 	<LoginWebModal
				// 		modalShowLoginPass={modalShowLoginPass}
				// 		setModalShowLoginPass={setModalShowLoginPass}
				// 	/>
				// )
				null}
			<CancelModal
				show={modalCancel}
				onHide={closeCancelModal}
				title={t('modal.shop.are_you_cancel').replace(
					'_PACKAGE_',
					packageSelect,
				)}
				handleCancel={handleCancel}
			/>
			<OTPConfirmModal
				isShopPage="shopPage/PackageCard"
				show={modalShowOTP}
				onHide={closeOTPModal}
				phone={user?.msisdn}
				dataSelect={itemSelect}
				transactionId={transactionId}
				tabValue={tabValue}
				handleLocalstorage={handleLocalstorage}
			/>
		</>
	)
}

export default PackageCard
